import React, { useState } from 'react';
import './serviceNode.css';
import { PageContainer, Button } from '../../../components/common';
import { ELEMENT_IDS } from '../../../constants/ids';
import { COMPANY_CONFIG } from '../../../constants/companyConfig';

const ServiceNode = () => {
  const [selectedServices, setSelectedServices] = useState([]);
  const useAlternate = COMPANY_CONFIG.features?.customNodeHandling;
  const services =
    useAlternate
      ? [
          { name: 'Internet', icon: 'internet.svg', id: 'internet' },
          { name: 'Video', icon: 'video.svg', id: 'video' },
          { name: 'Voice', icon: 'voice.svg', id: 'voice' },
          { name: 'Wireless', icon: 'wireless.svg', id: 'wireless' },
          {
            name: 'Home Security',
            icon: 'home-security.svg',
            id: 'home-security',
          },
        ]
      : [
          {
            name: 'Internet',
            id: 'internet',
            description: 'High-speed internet up to 1 Gbps.',
          },
          {
            name: 'Video',
            id: 'video',
            description: 'Access to 150+ HD channels and on-demand content.',
          },
          {
            name: 'Voice',
            id: 'voice',
            description: 'Unlimited nationwide calling with voicemail.',
          },
          {
            name: 'Wireless',
            id: 'wireless',
            description: '5G wireless coverage with flexible data plans.',
          },
        ];

  const handleServiceClick = (serviceId) => {
    if (selectedServices.includes(serviceId)) {
      setSelectedServices((prev) => prev.filter((id) => id !== serviceId));
    } else {
      setSelectedServices((prev) => [...prev, serviceId]);
    }
  };
  return (
    <PageContainer className="chooseProductsNode-Container">
      <div id="chooseProduct" className="headline">
        <h2>{useAlternate ? "Choose Your Services" : "Find Your Perfect Plan"}</h2>
        <h3>
          {useAlternate ? `No equipment fees, no data caps, no contracts. You can make changes at any time.` : `Find the perfect plan to fit your needs. Explore our options and pick
          the one that's right for you.`}
          
        </h3>
      </div>

      <div className="planWrapper">
        {useAlternate ? (
          <div className="serviceCards">
            {services.map((service) => (
              <div
                key={service.id}
                id={ELEMENT_IDS.NEXT_STEP_BUTTON}
                className="serviceCard"
                onClick={() => handleServiceClick(service.id)}
              >
                <img
                  src={require(`../../../assets/icons/plan/${service.icon}`)}
                  alt={`${service.name} icon`}
                  className="serviceIcon"
                />
                <p>{service.name}</p>
              </div>
            ))}
          </div>
        ) : (
          <div className="serviceAccordion">
            {services.map((service) => {
              const isActive = selectedServices.includes(service.id);
              return (
                <div key={service.id} className="accordionItem">
                  <div
                    className={`accordionHeader ${isActive ? 'active' : ''}`}
                    onClick={() => handleServiceClick(service.id)}
                  >
                    <p>{service.name}</p>
                    <span>{isActive ? '▲' : '▼'}</span>
                  </div>

                  {isActive && (
                    <div className="accordionBody">
                      <p>{service.description}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}

        <div className="buttonRow">
          <Button
            node="chooseProductsNode"
            customId={ELEMENT_IDS.PREVIOUS_STEP_BUTTON}
            label="Back"
            variant="secondary"
          />
        </div>
      </div>
    </PageContainer>
  );
};

export default ServiceNode;
